var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiltreCertificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "#FAF8F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 30,
    height: 30,
    fill: "white",
    stroke: "#E6E6E7",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000 9.000) scale(0.4857)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4026 2.77983C12.8819 1.07859 15.0649 0 17.5 0C19.9349 0 22.1178 1.07848 23.5972 2.77956C25.8463 2.62242 28.1529 3.40336 29.8749 5.12538C31.5969 6.8474 32.3779 9.15401 32.2208 11.4032C33.9216 12.8824 35 15.0653 35 17.5C35 19.9353 33.9213 22.1184 32.2199 23.5977C32.3766 25.8465 31.5957 28.1526 29.874 29.8744C28.1522 31.596 25.8462 32.377 23.5974 32.2203C22.118 33.9215 19.9351 35 17.5 35C15.0651 35 12.8822 33.9215 11.4029 32.2205C9.1537 32.3777 6.84708 31.5967 5.12502 29.8747C3.40301 28.1526 2.62206 25.846 2.7792 23.5968C1.07834 22.1175 0 19.9347 0 17.5C0 15.0651 1.07845 12.8822 2.77945 11.4029C2.62249 9.15394 3.40345 6.84756 5.12533 5.12569C6.84722 3.4038 9.15361 2.62283 11.4026 2.77983ZM23.98 14.2439C24.4122 13.639 24.2721 12.7983 23.667 12.3661C23.0621 11.934 22.2214 12.0741 21.7892 12.6791L15.9821 20.809L13.0673 17.8943C12.5416 17.3686 11.6892 17.3686 11.1635 17.8943C10.6378 18.4201 10.6378 19.2723 11.1635 19.798L15.202 23.8364C15.4818 24.1163 15.8704 24.2588 16.2649 24.2261C16.6593 24.1936 17.0193 23.989 17.2493 23.667L23.98 14.2439Z",
    fill: "url(#filtreCertificationIcon_paint0_linear_5003_4793)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "filtreCertificationIcon_paint0_linear_5003_4793",
    x1: 15.3987,
    y1: 33.7852,
    x2: 21.1773,
    y2: -16.6463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D38FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A6FF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltreCertificationIcon);
export default __webpack_public_path__ + "static/media/filtreCertificationIcon.984ea588467ad73b28303d4ad3460b7e.svg";
export { ForwardRef as ReactComponent };